import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppErrors, ConflictError, NotFoundError } from '@fitness-force/models';;
import { environment } from '@fitness-force/environments';
import { map, catchError, throwError } from 'rxjs';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root',
})
export class ChargeMasterService {
  private http = inject(HttpClient);
  private router = inject(Router);

  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  // Charge Master
  getChargeMasters(tenantId: number,allParams:Array<string>=[]) {
    let parsedParams = new HttpParams()
    if(allParams.length > 0){

     allParams.forEach((p: any) => {

       parsedParams = parsedParams.append(p.name, p.value);
     });
    }
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGE_MASTER.GET_CHARGE_MASTERS
      .replace('{tenant_id}', tenantId.toString());
    return this.http
      .get(
        url,
        {headers: this.httpOptions.headers , params: parsedParams}
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getSingleChargeMaster(tenantId: number, charge_master_id: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGE_MASTER.GET_CHARGE_MASTER_BY_ID
      .replace('{tenant_id}', tenantId.toString())
      .replace('{charge_master_id}', charge_master_id.toString());
    return this.http
      .get(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  createChargeMaster(tenantId: number, createChargeMasters: any) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGE_MASTER.CREATE_CHARGE_MASTER
      .replace('{tenant_id}', tenantId.toString());
    return this.http
      .post(
        url,
        createChargeMasters,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updateChargeMaster(tenantId: number, charge_master_id: number, data: any) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGE_MASTER.UPDATE_CHARGE_MASTER
      .replace('{tenant_id}', tenantId.toString())
      .replace('{charge_master_id}', charge_master_id.toString());
    return this.http
      .put(
        url,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  activeChargeMaster(tenantId: number, charge_master_id: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGE_MASTER.MARK_CHARGE_MASTER_ACTIVE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{charge_master_id}', charge_master_id.toString());
    return this.http
      .post(
        url,
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
  inActiveChargeMaster(tenantId: number, charge_master_id: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGE_MASTER.MARK_CHARGE_MASTER_INACTIVE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{charge_master_id}', charge_master_id.toString());
    return this.http
      .post(
        url,
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  deleteChargeMaster(tenantId: number, charge_master_id: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGE_MASTER.DELETE_CHARGE_MASTER
      .replace('{tenant_id}', tenantId.toString())
      .replace('{charge_master_id}', charge_master_id.toString());
    return this.http
      .delete(
        url
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  // Charge master category
  getChargeCategoryMasters(tenantId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGE_MASTER.GET_CHARGE_CATEGORY_MASTERS
      .replace('{tenant_id}', tenantId.toString());
    return this.http
      .get(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getSingleChargeCategoryMaster(
    tenantId: number,
    charge_master_category_id: number
  ) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGE_MASTER.GET_CHARGE_CATEGORY_MASTER_BY_ID
      .replace('{tenant_id}', tenantId.toString())
      .replace('{charge_category_master_id}', charge_master_category_id.toString());
    return this.http
      .get(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  createChargeCategoryMasters(
    tenantId: number,
    createChargeCategoryMaster: any
  ) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGE_MASTER.CREATE_CHARGE_CATEGORY_MASTER
      .replace('{tenant_id}', tenantId.toString());
    return this.http
      .post(
        url,
        createChargeCategoryMaster,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updateChargeCategoryMaster(
    tenantId: number,
    createChargeCategoryMaster: number,
    data: any
  ) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGE_MASTER.UPDATE_CHARGE_CATEGORY_MASTER
      .replace('{tenant_id}', tenantId.toString())
      .replace('{charge_category_master_id}', createChargeCategoryMaster.toString());
    return this.http
      .put(
        url,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  activeChargeCategoryMaster(
    tenantId: number,
    charge_category_master_id: number
  ) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGE_MASTER.MARK_CHARGE_CATEGORY_MASTER_ACTIVE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{charge_category_master_id}', charge_category_master_id.toString());
    return this.http
      .post(
        url,
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
  inActiveChargeCategoryMaster(
    tenantId: number,
    charge_category_master_id: number
  ) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGE_MASTER.MARK_CHARGE_CATEGORY_MASTER_INACTIVE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{charge_category_master_id}', charge_category_master_id.toString());
    return this.http
      .post(
        url,
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  deleteChargeCategoryMaster(
    tenantId: number,
    charge_category_master_id: number
  ) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGE_MASTER.DELETE_CHARGE_CATEGORY_MASTER
      .replace('{tenant_id}', tenantId.toString())
      .replace('{charge_category_master_id}', charge_category_master_id.toString());
    return this.http
      .delete(
        url
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getTaxGroups(tenantId: number) {
    return this.http.get(`${this.BASE_URL}/tenant/${tenantId}/tax-groups`);
  }

  getAggregatedChargeMasters() {
    return this.http.get(`${environment.BASE_URL}/distinct_charge_masters`)
    .pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );    
  }
}
